// checkout/utils/preserveTabindex.ts

/**
 * Save current tabindex on element and set -1.
 *
 * @param {HTMLElement} el - Element to lock.
 * @returns {void}
 */
export function lockFocusable(el: HTMLElement): void {
	if (!el.hasAttribute('data-prev-tabindex')) {
		const prev = el.getAttribute('tabindex');
		el.setAttribute('data-prev-tabindex', prev === null ? '' : prev);
	}
	el.tabIndex = -1;
}

/**
 * Restore previously saved tabindex on element, if any.
 *
 * @param {HTMLElement} el - Element to restore.
 * @returns {void}
 */
export function restoreFocusable(el: HTMLElement): void {
	const prev = el.getAttribute('data-prev-tabindex');
	if (prev !== null) {
		if (prev === '') el.removeAttribute('tabindex');
		else el.setAttribute('tabindex', prev);
		el.removeAttribute('data-prev-tabindex');
	}
}
